import { useTranslation } from 'react-i18next';
import type { RegleNewsletter } from '../../api/newsletter.js';
import { useOptionsTypeContact } from '../../api/typesContact.js';
import { useShellContext } from '../shell/context.js';
/** Dit en une phrase qui entre dans une liste : types, langues, étiquettes. */
export function RegleListe({ regle }: { regle: RegleNewsletter }) {
  const { t } = useTranslation(['regie']);
  const typesContact = useOptionsTypeContact(useShellContext().galerieSlug);
  const morceaux = [
    regle.typesContact.length
      ? regle.typesContact.map((v) => typesContact.libelle(v)).join(' · ')
      : t('regie:newsletter.listes.tousLesTypes'),
    ...(regle.langues.length ? [regle.langues.map((v) => v.toUpperCase()).join(' · ')] : []),
    ...(regle.etiquettes.length ? [regle.etiquettes.map((v) => `#${v}`).join(' ')] : []),
  ];
  return <>{morceaux.join(' — ')}</>;
}
